import "./App.css";
import { Card, CardType, WordType } from "./Card";
import { pairs } from "./pairs";

function App() {
  return (
    <div className="App">
      <div className="App__container">
        <p className="App__permaQuestion">
          What's the <span className="App__actual">actual</span> plural for
        </p>
        <div className="App__phantomScrollSnap"></div>
        {pairs.map((pair) => {
          return (
            <section className="App__section">
              <div className="Card__pairContainer">
                <Card type={CardType.question} word={WordType.singular}>
                  {pair.question}
                </Card>
                <Card type={CardType.answer} word={WordType.plural}>
                  {pair.answer}
                </Card>
              </div>
            </section>
          );
        })}
      </div>
    </div>
  );
}

export default App;
